import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[arrowTooltip]',
})
export class ArrowTooltipDirective {
  @Input('arrowTooltip') tooltipText: string | null = null;
  @Input() tooltipColor: string | null = null;

  private tooltip: HTMLElement | null = null;

  constructor(private el: ElementRef) {}

  @HostListener('mouseenter')
  onMouseEnter() {
    if (!this.tooltipText) return;

    const bgColor = this.tooltipColor || '#1a1a1a';

    this.tooltip = document.createElement('div');
    this.tooltip.className = 'custom-tooltip-container';

    const textBox = document.createElement('div');
    textBox.className = 'custom-tooltip-box';
    textBox.textContent = this.tooltipText;
    textBox.style.backgroundColor = bgColor;
    this.tooltip.appendChild(textBox);

    const arrow = document.createElement('div');
    arrow.className = 'custom-tooltip-arrow';
    arrow.style.borderTopColor = bgColor; // promena boje strelice
    this.tooltip.appendChild(arrow);

    document.body.appendChild(this.tooltip);
    this.positionTooltip();

    setTimeout(() => {
      this.tooltip?.classList.add('show');
    }, 10);
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (this.tooltip) {
      this.tooltip.classList.remove('show');
      setTimeout(() => {
        if (this.tooltip) {
          document.body.removeChild(this.tooltip);
          this.tooltip = null;
        }
      }, 200);
    }
  }

  private positionTooltip() {
    if (!this.tooltip) return;

    const hostRect = this.el.nativeElement.getBoundingClientRect();
    const tooltipRect = this.tooltip.getBoundingClientRect();

    const top = hostRect.top - tooltipRect.height - 5;
    const left = hostRect.left + hostRect.width / 2 - tooltipRect.width / 2;

    this.tooltip.style.top = `${top}px`;
    this.tooltip.style.left = `${left}px`;
  }

  ngOnDestroy() {
    if (this.tooltip) {
      document.body.removeChild(this.tooltip);
    }
  }
}
